import PropTypes from 'prop-types';
import { useMemo } from 'react';
import createMemoizedContextProvider from './CreateMemoizedContextProvider';

const { useContext: useTestTypeArrayObjectContext, Provider } =
    createMemoizedContextProvider('TestTypeArrayObjectContext');

export const TestTypeArrayObjectContextProvider = ({ children, testTypeArrayObject }) => {
    const contextValue = useMemo(() => ({ testTypeArrayObject }), [testTypeArrayObject]);
    return <Provider value={contextValue}>{children}</Provider>;
};

TestTypeArrayObjectContextProvider.propTypes = {
    children: PropTypes.node,
    testTypeArrayObject: PropTypes.arrayOf(
        PropTypes.shape({
            _id: PropTypes.string,
            group: PropTypes.string,
            name: PropTypes.string,
        })
    ),
};

TestTypeArrayObjectContextProvider.defaultProps = {
    children: null,
    testTypeArrayObject: [],
};

export default useTestTypeArrayObjectContext;
